import {useState} from "react";
import {App as AntdApp, Alert, Button} from "antd";
import {useCurrentUser} from "~/hooks";
import {handleRequest} from "~/utils";
import {authApi} from "~/api";

/**
 * Banner nhắc xác minh email — hiện đầu trang (DefaultLayout, cạnh LoginAsBanner) khi
 * user đăng nhập có `email_verified === false` (chỉ user đăng ký mới; user cũ không meta
 * = true nên không thấy banner). Nút "Gửi lại" gọi resend (BE cooldown 2 phút).
 */
function EmailVerifyBanner() {

	const {notification} = AntdApp.useApp();
	const currentUser = useCurrentUser();
	const [sending, setSending] = useState(false);
	const [dismissed, setDismissed] = useState(false);

	// Chỉ hiện khi BE trả email_verified=false tường minh (user cũ không có field/true → ẩn).
	if (!currentUser || currentUser.email_verified !== false || dismissed) return null;

	const resend = async () => {
		setSending(true);
		const [error, response] = await handleRequest(authApi.resendVerifyEmail());
		setSending(false);
		if (error || !response) {
			notification.error({
				message: 'Không gửi được email',
				description: error?.response?.data?.message || 'Có lỗi xảy ra, thử lại sau.',
			});
			return;
		}
		notification.success({message: 'Đã gửi', description: response?.message || 'Vui lòng kiểm tra hộp thư (kể cả mục Spam).'});
	};

	return (
		<Alert
			type="warning"
			showIcon
			closable
			onClose={() => setDismissed(true)}
			style={{marginBottom: 14}}
			message={<span>Email <strong>{currentUser.email}</strong> chưa được xác minh — hãy mở hộp thư và bấm vào liên kết xác minh.</span>}
			action={
				<Button size="small" loading={sending} onClick={resend}>
					Gửi lại email xác minh
				</Button>
			}
		/>
	);
}

export default EmailVerifyBanner;
